// src/components/static/Guide.jsx
import React from 'react';
import SEO from '../common/seo/SEO';
import { Link } from 'react-router-dom';

const Guide = () => {
  return (
    <>
      <SEO 
        title="이용가이드"
        description="FairNex AI 에이전트 서비스 이용 가이드"
      />

      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* 타이틀 섹션 */}
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold mb-4">FairNex 이용가이드</h1>
          <p className="text-gray-600">
            AI 에이전트와 함께 더 스마트하게 업무를 처리하는 방법을 안내합니다.
          </p>
        </div>

        {/* 단계별 가이드 */}
        <div className="space-y-12">
          {/* 1단계: 서비스 선택 */}
          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <span className="text-2xl mr-3">1️⃣</span>
              <h2 className="text-xl font-semibold">서비스 선택</h2>
            </div>
            <div className="ml-10">
              <p className="text-gray-600 mb-4">
                필요한 업무에 맞는 AI 서비스를 선택해주세요.
              </p>
              <ul className="list-disc ml-6 space-y-2 text-gray-600">
                <li>PDF 분석: 문서 요약, 핵심 내용 추출, 인사이트 도출</li>
                <li>운세 상담: 사주 분석, 운세 해석, 맞춤형 조언</li>
                <li>이메일 작성: 상황에 맞는 이메일 초안 작성</li>
                <li>업무 자동화: 반복적인 업무의 자동 처리</li>
              </ul>
            </div>
          </section>

          {/* 2단계: 상세 설정 */}
          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <span className="text-2xl mr-3">2️⃣</span>
              <h2 className="text-xl font-semibold">상세 설정</h2>
            </div>
            <div className="ml-10">
              <p className="text-gray-600 mb-4">
                선택한 서비스에 맞는 세부 옵션을 설정해주세요.
              </p>
              <ul className="list-disc ml-6 space-y-2 text-gray-600">
                <li>분석 수준 선택: 간단/표준/상세 분석 중 선택</li>
                <li>분석 관점 설정: 일반/비즈니스/기술적 관점 중 선택</li>
                <li>추가 요구사항 입력: 특별히 고려해야 할 사항 입력</li>
              </ul>
            </div>
          </section>

          {/* 3단계: 결과 확인 */}
          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <span className="text-2xl mr-3">3️⃣</span>
              <h2 className="text-xl font-semibold">결과 확인</h2>
            </div>
            <div className="ml-10">
              <p className="text-gray-600 mb-4">
                AI가 분석하고 처리한 결과를 확인하세요.
              </p>
              <ul className="list-disc ml-6 space-y-2 text-gray-600">
                <li>분석 결과 및 요약 내용 확인</li>
                <li>주요 포인트 및 인사이트 검토</li>
                <li>필요시 추가 분석 요청 가능</li>
                <li>결과 다운로드 및 공유 기능 활용</li>
              </ul>
            </div>
          </section>

          {/* 활용 팁 */}
          <section className="bg-blue-50 p-6 rounded-lg">
            <h2 className="text-lg font-semibold mb-4 text-blue-800">💡 활용 팁</h2>
            <ul className="space-y-2 text-blue-800">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <p>상세한 요구사항을 입력할수록 더 정확한 결과를 얻을 수 있습니다.</p>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <p>분석 목적에 맞는 적절한 옵션을 선택하면 효율적입니다.</p>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <p>피드백을 통해 AI 서비스의 품질 향상에 기여할 수 있습니다.</p>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <p>정기적으로 새로운 기능과 업데이트를 확인해보세요.</p>
              </li>
            </ul>
          </section>
        </div>

        {/* 시작하기 버튼 */}
        <div className="mt-12 text-center">
          <Link
            to="/services"
            className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            FairNex 시작하기
            <span className="ml-2">→</span>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Guide;